/**
 * AiCategoryChipStrip — horizontal filter chips driven by AIOpsEngine.
 *
 * Renders one chip per AI category with its live count. Clicking a chip
 * toggles it (the parent decides how to filter). Used on both /admin/jobs
 * and /admin/shifts so the operator sees the same taxonomy everywhere.
 */
import React from 'react';
import { CATEGORIES, TONE_STYLES } from '../utils/aiOpsEngine';

export default function AiCategoryChipStrip({ countsByCategory = {}, active, onSelect }) {
  return (
    <div
      className="flex gap-1.5 overflow-x-auto pb-2 -mx-1 px-1 mb-3"
      data-testid="ai-category-chips"
    >
      <button
        type="button"
        onClick={() => onSelect(null)}
        className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
          active === null || active === undefined
            ? 'bg-slate-900 text-white border-slate-900'
            : 'bg-white text-slate-700 border-slate-300 hover:border-slate-500'
        }`}
        data-testid="ai-category-chip-all"
      >
        All
      </button>
      {CATEGORIES.map((c) => {
        const count = countsByCategory[c.id] || 0;
        const isActive = active === c.id;
        const style = TONE_STYLES[c.tone];
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onSelect(isActive ? null : c.id)}
            data-testid={`ai-category-chip-${c.id}`}
            className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition flex items-center gap-1.5 ${
              isActive
                ? `${style.chip} ring-2 ${style.ring}`
                : 'bg-white text-slate-700 border-slate-300 hover:border-slate-400'
            }`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} />
            {c.label}
            <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
              isActive ? 'bg-white/60' : 'bg-slate-100 text-slate-600'
            }`}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
